import React, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { history } from '../../utils/variables';
import OutlineHome from '../../assets/images/icons/dark-home.png'
import FillHome from '../../assets/images/gifs/home-2_1.gif'
// import FillHome from '../../assets/images/icons/light-home.png'
import OutlineCar from '../../assets/images/icons/dark-car.png'
import FillCar from '../../assets/images/gifs/car-2.gif'
// import FillCar from '../../assets/images/icons/light-car.png'
import OutlineProfile from '../../assets/images/icons/dark-profile.png'
import FillProfile from '../../assets/images/gifs/profile-2.gif'
// import FillProfile from '../../assets/images/icons/light-profile.png'
import { toast } from '../../utils/functions';


export default function Footer() {

    const location = useLocation();
    const indicator = useRef(null);
    const footerRef = useRef(null);

    const hideFooter = useMemo(() => {
        return [
            '/tutorial',
            '/login',
            '/error',
            '/rules',
            '/third-party-login'
        ].includes(location.pathname);
    }, [location.pathname]);
    const activeLocation = useMemo(() => {
        const path = location.pathname;
        if (['/edit-profile', '/wallet', '/rules'].includes(path)) return 'profile';
        //else if (path === '/about') return 'about';
        else if (path === '/') return 'home';
        return 'crash';
    }, [location.pathname]);
    useEffect(()=>{
        function justifyItems() {
            const footer = footerRef.current.getBoundingClientRect().width
            if(activeLocation === 'home'){
                indicator.current.style.transform = 'translateX(0)'
            }else if(activeLocation === 'profile'){
                indicator.current.style.transform = `translateX(${footer/3}px)`
            }else {
                indicator.current.style.transform = `translateX(-${footer/3}px)`
            }
        }
        !hideFooter && justifyItems()
    },[activeLocation])
    const [disabled ,setDisabled] = useState(false);
    const disablePagesUser = ['/user-info','/user-images','/complete' , '/select-expert', '/get_location','/losses-info','/assess-type']
    const disablePagesExpert = ['/culprit-detail' , '/losses-detail', '/expert-images','/final-pricing']
    const disablePagesregister = ['/register-data','/register-capturing','/register-video']
    function DisabledFooter(){
        const path = location.pathname;
        if(disablePagesUser.includes(path)){
            toast('شما در حال ثبت پرونده هستید!','error');
        }
        if(disablePagesExpert.includes(path)){
            toast('شما در حال کارشناسی هستید!','error');
        }
        if(disablePagesregister.includes(path)){
            toast('شما در حال صدور بیمه نامه هستید!','error');
        }
    }
    useEffect(()=>{
        const path = location.pathname;
        if(disablePagesUser.includes(path) || disablePagesExpert.includes(path) || disablePagesregister.includes(path)){
            setDisabled(true)
            return;
        }
        // if(disablePagesExpert.includes(path)){
        //     setDisabled(true)
        //     return;
        // }
        setDisabled(false)
    },[location.pathname])
    return (
        !hideFooter &&
        <div className='footer' onClick={DisabledFooter} ref={footerRef}>
            <div
                className={activeLocation === 'crash' ? 'link active' : 'link'}
                // to='/report-list'
                onClick={()=> !disabled && history.push('/report-list')}
            >
                {/* <i className='fas fa-info-circle' /> */}
                {/* <i className='fas fa-car-crash'/> */}
                <img className='footer-icon' src={FillCar} style={{display: `${activeLocation === 'crash'? ' inline-block':'none'}`}} alt='home'/>
                <img className='footer-icon' src={OutlineCar} style={{display: `${activeLocation !== 'crash'? 'inline-block': 'none'}`}} alt='home'/>
                {/* <img className='footer-icon' src={activeLocation === 'crash' ? FillCar : OutlineCar} alt='home'/> */}
            </div>
            <div
                className={activeLocation === 'home' ? 'link active' : 'link'}
                // to='/'
                onClick={()=> !disabled && history.push('/')}
            >
                {/* <i className='fas fa-car-crash' /> */}
                {/* <i className='fas fa-home' /> */}
                <img 
                    className='footer-icon' src={FillHome} 
                    style={{display: `${activeLocation === 'home' ? 'inline-block' : 'none'}`}} 
                    alt='home'
                />
                <img 
                    className='footer-icon' src={OutlineHome}
                    style={{display: `${activeLocation !== 'home' ? 'inline-block' : 'none'}`}} 
                    alt='home'
                />
                {/* <img className='footer-icon' src={activeLocation === 'home' ? FillHome : OutlineHome} alt='home'/> */}
            </div>
            <div
                className={activeLocation === 'profile' ? 'link active' : 'link'}
                // to='/edit-profile'
                onClick={()=> !disabled && history.push('/edit-profile')}
            >
                {/* <i className='fas fa-user' /> */}
                <img className='footer-icon' src={FillProfile} style={{display: `${activeLocation === 'profile' ? 'inline-block' : 'none'}`}} alt='home'/>
                <img className='footer-icon' src={OutlineProfile} style={{display: `${activeLocation !== 'profile' ? 'inline-block' : 'none'}`}} alt='home'/>
                {/* <img className='footer-icon' src={activeLocation === 'profile' ? FillProfile : OutlineProfile} alt='home'/> */}
            </div>
            <span 
                className="indicator"
                ref={indicator} 
                // style={{transform :`translateX(${activeLocation === 'crash' ? '-125px' : activeLocation === 'profile' ? '125px' : '0'})`}}
                />
        </div>
    );
    
}
